import { deployContracts } from "./deploy/deployContracts"
import { fundAccounts } from "./deploy/fundAccounts"
import { type Bundler, toBundler } from "./toBundler"
import { toMeeNode } from "./toMeeNode"
import { type Network, toNetwork } from "./toNetwork"

export type ToEcosystemParameters = {
  chainLength?: number
  forkUrl?: string
}

export type Infra = { network: Network; bundler: Bundler }

// biome-ignore lint/suspicious/noExplicitAny: meeNode not available yet
export type Ecosystem = { meeNode: any; infras: Infra[] }

export const toEcosystem = async (parameters?: ToEcosystemParameters) => {
  const { chainLength = 1, forkUrl } = parameters ?? {}
  const infras = await Promise.all(
    Array.from({ length: chainLength }, async () => {
      const network = await toNetwork({ forkUrl })
      await fundAccounts(network)
      if (!forkUrl) {
        await deployContracts(network)
      }
      const bundler = await toBundler(network)
      return { network, bundler }
    })
  )

  return {
    meeNode: await toMeeNode({ infras }),
    infras
  }
}
